import { SearchBox } from '#src/app/pages/searchV2/shared/components';

import { ExploreButtons } from './components/ExploreButtons';
import { HeaderTitle } from './components/HeaderTitle';
import { PromotedPetitions } from './components/PromotedPetitions';
import { TopicsSection } from './components/TopicsSection';

export const LandingPageLayout: React.FC = () => {
	return (
		<>
			<HeaderTitle />
			<SearchBox />
			<ExploreButtons />
			<TopicsSection />
			<PromotedPetitions />
		</>
	);
};
